import { render } from "./effectiveModal.vue?vue&type=template&id=3b448afd"
import script from "./effectiveModal.vue?vue&type=script&lang=js"
export * from "./effectiveModal.vue?vue&type=script&lang=js"

import exportComponent from "/builds/aksoftware/software/haushaltsbuchfrontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__